import { useEffect, useState } from "react";
import { apiBase } from "./api";

// The platform's default review price and turnaround, served by /api/config so
// customer copy never repeats the numbers set on the server.
export type ReviewPrice = { priceCents: number; turnaroundHours: number };

let cached: Promise<ReviewPrice | null> | null = null;

function loadReviewPrice(): Promise<ReviewPrice | null> {
  cached ??= Promise.resolve()
    .then(() => fetch(`${apiBase}/api/config`))
    .then(r => (r.ok ? r.json() : null))
    .then(d =>
      d?.reviews?.price_cents && d?.reviews?.turnaround_hours
        ? {
            priceCents: d.reviews.price_cents,
            turnaroundHours: d.reviews.turnaround_hours,
          }
        : null
    )
    .catch(() => {
      cached = null;
      return null;
    });
  return cached;
}

export function useReviewPrice() {
  const [price, setPrice] = useState<ReviewPrice | null>(null);
  useEffect(() => {
    let active = true;
    void loadReviewPrice().then(p => {
      if (active) setPrice(p);
    });
    return () => {
      active = false;
    };
  }, []);
  return price;
}

export const formatPrice = (cents: number) =>
  `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}`;
